module.exports = __webpack_public_path__ + "static/media/Portal_Logo_Small.e2e52f73.svg";